import { combineReducers } from '@reduxjs/toolkit';

import autocomplete from './autocomplete/index';
import dialog from './dialog';
import fitmentSearch from './fitmentSearch/index';
import product from './product';
import search from './search/index';
import show from './show';

export default combineReducers({
  autocomplete,
  dialog,
  fitmentSearch,
  product,
  search,
  show,
});
